export default __webpack_public_path__ + "static/media/TransferContact.0714d54b.svg";